import { cls } from "app/utils";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

import { AnalyzePlanCode } from "app/utils/planPricing";

// Re-export of the shared plan-code union so existing imports keep working.
export type AnalyzePlanType = AnalyzePlanCode;

interface PricingToggleProps {
  planCode: AnalyzePlanType;
  onPlanSelect: (planCode: AnalyzePlanType) => void;
  discount?: string;
  // When given, only these terms can be picked: a re-price offers the terms
  // the subscription may move to.
  availablePlans?: AnalyzePlanType[];
}

// No default for `discount`: the badge must disappear when the caller passes
// undefined to yield to an applied promo (a default would silently resurface).
const PricingToggle: React.FC<PricingToggleProps> = ({
  planCode,
  onPlanSelect,
  discount,
  availablePlans,
}) => {
  const { t } = useTranslation();
  const unavailable = (code: AnalyzePlanType) =>
    availablePlans != null && !availablePlans.includes(code);

  return (
    <div className={styles.toggle_container}>
      <button
        className={cls(styles.toggle_button, {
          [styles.active]: planCode === "analyze+yearly",
          [styles.disabled]: unavailable("analyze+yearly"),
        })}
        disabled={unavailable("analyze+yearly")}
        onClick={() => onPlanSelect("analyze+yearly")}
      >
        {t("Annual")}
        {planCode === "analyze+yearly" && discount && (
          <span className={styles.discount_badge}>{discount}</span>
        )}
      </button>
      <button
        className={cls(styles.toggle_button, {
          [styles.active]: planCode === "analyze+monthly",
          [styles.disabled]: unavailable("analyze+monthly"),
        })}
        disabled={unavailable("analyze+monthly")}
        onClick={() => onPlanSelect("analyze+monthly")}
      >
        {t("Monthly")}
      </button>
    </div>
  );
};

export default PricingToggle;
